import React, { useContext } from 'react'
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';
import { FaUserSecret, FaUserTie, FaUser/*, FaRegEye, FaRegEdit*/ } from "react-icons/fa";
import { BsTrash } from "react-icons/bs";
import Swal from 'sweetalert2';

const Cuenta = ({cuenta}) => {

    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { eliminarUsuario } = barrapplContext;

    const confirmarEliminarUsuario = id => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Un tarea que se elimina no se puede recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f3848',
            cancelButtonColor: '#be3434',
            confirmButtonText: 'Si, ¡eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                eliminarUsuario(id);
            }
        });
    }

    return (
        <li className="users sombra">
            <div className="img-perfil">
                {cuenta.rol === 'Administrador' ? (
                    <FaUserSecret />
                ) : cuenta.rol === 'Asistente Administrativa' || cuenta.rol === 'SQL Developer' ? (
                    <FaUserTie />
                ) : (
                    <FaUser />
                )}
            </div>

            <div className="user-nombre">
                <p>{cuenta.nombre}</p>
            </div>

            <div className="user-rol">
                <p>{cuenta.rol}</p>
            </div>

            <div className="acciones">
                {/* <button
                    type="button"
                    className="btn btn-ver-user"    
                    // onClick={() => verTareaActual(tarea)}
                >
                    <FaRegEye />
                </button>

                <button
                    type="button"
                    className="btn btn-editar-user"   
                    // onClick={() => seleccionarTarea(tarea)} 
                >
                    <FaRegEdit />
                </button> */}
                
                <button
                    type="button"
                    className="btn btn-eliminar-user"
                    onClick={() => confirmarEliminarUsuario(cuenta._id)}
                >
                    <BsTrash />
                </button>
            </div>
        </li>
    );
}
 
export default Cuenta;